import app from "@/main";
import {UyapRequest} from "@/plugins/uyap-plugin/uyap/UyapRequest";

export interface AvukatBakiyeSorgulaTalep {}

export interface AvukatBakiyeSorgulaCevap {
    log: string;
    type: string;
    value: string;
    message?: string;
}

export default class AvukatBakiyeSorgula extends UyapRequest<AvukatBakiyeSorgulaTalep, AvukatBakiyeSorgulaCevap> {
    delayTime = 0;

    getMethod(): "POST" | "GET" {
        return "GET";
    }

    getSpinnerMessage(){
        return "Avukat bakiyesi sorgulanıyor...";
    }

    cache() {
        const kimlikNo = app.$store?.getters?.userData?.kimlik_no ?? "anonymous";
        return {
            active: false,
            ttl: 60,
            key: `AvukatBakiyeSorgula_${kimlikNo}`
        };
    }

    getMockResponse(): AvukatBakiyeSorgulaCevap {
        return {
            type: "success",
            message: "Mock bakiye cevabi",
            value: "0.00",
            log: ""
        };
    }

    getUrl(): string {
        return this.ImzaClientAddr + "avukatBakiyeSorgula.ajx";
    }

    async parse(data: any): Promise<AvukatBakiyeSorgulaCevap> {
        const raw = Array.isArray(data) ? data[0] : data;
        const response: AvukatBakiyeSorgulaCevap = {
            type: raw?.type ?? "error",
            value: raw?.value ?? "0",
            log: raw?.log ?? "",
            message: raw?.message
        };

        if (!response.message) {
            response.message = response.type === "success" ? "Sorgu başarılı" : "Sorgu tamamlanamadı";
        }
        return response;
    }
}
